import * as React from "react";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Bubble } from "../../../components/Icons/Bubble";
import { api } from "../../../api/api";
import { LATAM_COUNTRY_NAMES } from "../../../features/countries/types";

import theme from "../../../components/styles/theme/theme";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";

export const SummaryPage: React.FC = () => {
  const { t } = useTranslation();
  const isSmScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    map: { selectedCountry },
  } = useSelector((state: RootState) => state);

  return (
    <>
      {selectedCountry?.country_name === LATAM_COUNTRY_NAMES.LATAM && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            textAlign: "center",
            paddingBottom: "10px",
          }}
        >
          <Typography
            component="span"
            margin="auto 0"
            variant="body2"
            color={theme.palette.text.secondary}
          >
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          textAlign: "center",
        }}
        className='hidden-print'
      >
        <Typography
          component="span"
          margin="auto 0"
          fontWeight="500"
          variant="body1"
          color={theme.palette.text.secondary}
          className="sources_and_methodology"
        >
          {t("common.sources_and_methodology")}
        </Typography>
        <Button
          onClick={api.getMethodology}
          sx={{ color: theme.palette.custom.blue, textTransform: "none" }}
        >
          {t("common.download_pdf")}
        </Button>
      </Box>
      {!isSmScreen && (
        <Bubble
          style={{
            position: "absolute",
            transform: "translate(115px,-94px)",
            zIndex: -1,
          }}
        />
      )}
    </>
  );
};
